// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumbs_root__zqTRB","item":"Breadcrumbs_item__zfKmH","clickable":"Breadcrumbs_clickable__FiiY2","home":"Breadcrumbs_home__Y7gb3"};